<template>
  <div class="widget-body">
    <v-alert show tabindex="0" v-if="!ric" variant="light" align="center">{{ i18n('messages.noRic') }}</v-alert>
    <c-loader v-else-if="isLoading" />
    <v-alert show v-else-if="isError" variant="red" align="center">{{ i18n('messages.error') }} </v-alert>
    <template v-else>
      <h5>{{ i18n('titleDividends') }}</h5>
      <v-alert show v-if="!dividendsItems.length" variant="light" align="center">{{ i18n('messages.nodata') }}</v-alert>
      <b-table
        v-else
        dark
        striped
        selectable
        select-mode="single"
        bordered
        small
        hover
        :fields="dividendsFields"
        :items="dividendsItems"
        @head-clicked="return false;"
        :aria-label="i18n('titleDividends')"
        @keydown.tab.native="suppressTab"
      >
        <template v-slot:head(_DIV_ANNOUNCEMENT_DATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_DIV_EX_DATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_DIV_PAY_DATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_DIV_RATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_DIV_CURRENCY)="field">{{ i18n(field.label) }}</template>
      </b-table>

      <h5 tabindex="0">{{ i18n('titleCapitalChanges') }}</h5>
      <v-alert show variant="light" tabindex="0" v-if="!capitalChangesItems.length" align="center">{{
        i18n('messages.nodata')
      }}</v-alert>
      <b-table
        v-else
        dark
        striped
        selectable
        select-mode="single"
        bordered
        small
        hover
        thead-class="text-center"
        :fields="capitalChangesFields"
        :items="capitalChangesItems"
        @head-clicked="return false;"
        :aria-label="i18n('titleCapitalChanges')"
        @keydown.tab.native="suppressTab"
      >
        <template v-slot:head(_ANNOUNCEMENT_DATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_EX_DATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_DEAL_DATE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_CAPCHG_TYPE)="field">{{ i18n(field.label) }}</template>
        <template v-slot:head(_ADJUSTMENT_FACTOR)="field">{{ i18n(field.label) }}</template>
      </b-table>
    </template>
  </div>
</template>

<script>
import CLoader from '@custom/CLoader';

import { API } from '@/state/api';

export default {
  name: 'w-dividends-capital-changes',
  components: {
    CLoader
  },
  props: {
    ric: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      capitalChangesFields: [
        {
          key: '_ANNOUNCEMENT_DATE',
          label: 'fields.announcement',
          formatter: val => this.$f(val, 'date')
        },
        {
          key: '_EX_DATE',
          label: 'fields.ex-date',
          formatter: val => this.$f(val, 'date')
        },
        {
          key: '_DEAL_DATE',
          label: 'fields.pay-date',
          formatter: val => this.$f(val, 'date')
        },
        {
          key: '_CAPCHG_TYPE',
          label: 'fields.corporate-action'
        },
        {
          key: '_ADJUSTMENT_FACTOR',
          label: 'fields.factor',
          formatter: val => this.$f(val, 'float')
        }
      ],
      capitalChangesItems: [],
      dividendsItems: [],
      dividendsFields: [
        {
          key: '_DIV_ANNOUNCEMENT_DATE',
          label: 'fields.announcement',
          formatter: val => this.$f(val, 'date')
        },
        {
          key: '_DIV_EX_DATE',
          label: 'fields.ex-date',
          formatter: val => this.$f(val, 'date')
        },
        {
          key: '_DIV_PAY_DATE',
          label: 'fields.pay-date',
          formatter: val => this.$f(val, 'date')
        },
        {
          key: '_DIV_RATE',
          label: 'fields.dividend',
          formatter: val => this.$f(val, 'float.price')
        },
        {
          key: '_DIV_CURRENCY',
          label: 'fields.currency'
        }
      ],
      isError: false,
      isLoading: false
    };
  },
  watch: {
    ric: {
      handler() {
        this.fetch();
      },
      immediate: true
    }
  },
  methods: {
    i18n(subkey, ns) {
      return this.$t(`white-label.${ns || 'widgets.dividendsCapitalChanges'}.${subkey}`);
    },
    nsify(data, ns) {
      if (typeof data === 'string') return ns + '.' + data;
      return data.map(val => {
        return Object.keys(val).reduce((acc, fid) => {
          acc[fid.replace(/[^.]+\./, '')] = val[fid];
          return acc;
        }, {});
      });
    },
    fetch() {
      if (!this.ric) {
        return;
      }
      this.isLoading = true;
      Promise.all([this.fetchData('dividends'), this.fetchData('capitalChanges')])
        .then(() => (this.isError = false))
        .catch(err => {
          console.error(err);
          this.isError = true;
        })
        .finally(() => (this.isLoading = false));
    },
    fetchData(species) {
      return API.Rest.get(
        '/find/shares' +
          '?fids=q.RIC,' +
          this[species + 'Fields'].map(field => this.nsify(field.key, species.substr(0, 3))) +
          '&search=' +
          this.ric +
          '&searchFor=RIC'
      ).then(response => {
        this[species + 'Items'] = this.nsify(response.data.data).sort((a, b) =>
          this.sortData(a, b, (species === 'dividends' ? '_DIV' : '') + '_ANNOUNCEMENT_DATE')
        );
      });
    },
    sortData(a, b, col) {
      a = a[col] === '-' ? a[col.replace('ANNOUNCEMENT', 'EX')] : a[col];
      b = b[col] === '-' ? b[col.replace('ANNOUNCEMENT', 'EX')] : b[col];
      return a < b ? 1 : a > b ? -1 : 0;
    },
    suppressTab(event) {
      event.preventDefault();
    }
  }
};
</script>
